import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    aaa: 1
  },

  mutations: {
    
  },
  actions: {},
  modules: {}
})



// WEBPACK FOOTER //
// ./src/store/index.js